import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  CssBaseline,
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Box } from "@mui/system";
import { toast } from "react-toastify";
import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

const muiCache = createCache({
  key: "mui-datatables",
  prepend: true,
});

export default function DeleteCarrierDatatable({ data }) {
  const [responsive, setResponsive] = useState("vertical");
  const [tableBodyHeight, setTableBodyHeight] = useState("400px");
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");
  const [searchBtn, setSearchBtn] = useState(true);
  const [downloadBtn, setDownloadBtn] = useState(true);
  const [printBtn, setPrintBtn] = useState(true);
  const [viewColumnBtn, setViewColumnBtn] = useState(true);
  const [filterBtn, setFilterBtn] = useState(true);
  const [datta, setdatta] = useState();
  // const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // console.log(data, "helloppp");

  const columns = [
    {
      name: "S_no",
    },

    "Username_Name",
    "Status",
    "Role",
    "E_Mail",
    "Actions",
  ];

  const options = {
    search: searchBtn,
    download: downloadBtn,
    print: printBtn,
    viewColumns: viewColumnBtn,
    filter: filterBtn,
    filterType: "dropdown",
    responsive,
    tableBodyHeight,
    tableBodyMaxHeight,
    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
    },
  };

  function Deleted(index) {
    console.log("deleted item .....", index);
  }
  function onRowSelectionChange(index) {
    console.log("selected item .....", index);
  }

  let data1 = [];

  if (data !== undefined) {
    data.forEach((element, index) => {
      console.log(element, "----------------");
      data1.push({
        S_no: index,
        Username_Name: element.username,
        Status: element.approved,

        Role: element.userRoleId,
        E_Mail: element.email,
        Actions: (
          <>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Actions
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>Edit</MenuItem>
              {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
              <MenuItem onClick={handleClose}>Delete</MenuItem>
            </Menu>
          </>
        ),
      });
    });
  }
  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
      <CacheProvider value={muiCache}>
        <ThemeProvider theme={createTheme()}>
          {data == undefined ? (
            <Box>
              <Skeleton />
              <Skeleton animation="wave" />
              <Skeleton animation={true} />
              <CssBaseline />
            </Box>
          ) : (
            // return (
            <>
              <MUIDataTable
                title={"Details of Users Account to Manage"}
                data={data1}
                columns={columns}
                options={options}
              />
            </>
            // )
          )}
        </ThemeProvider>
      </CacheProvider>
    </main>
  );
}
